var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip5000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4116)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9062 35.7031C33.6042 35.7031 34.224 35.8359 34.7656 36.1016C35.3125 36.3672 35.7422 36.7578 36.0547 37.2734C36.3672 37.7891 36.5234 38.4245 36.5234 39.1797C36.5234 40.0026 36.3516 40.7135 36.0078 41.3125C35.6693 41.9062 35.1615 42.362 34.4844 42.6797C33.8125 42.9974 32.974 43.1562 31.9688 43.1562C31.3698 43.1562 30.8047 43.1042 30.2734 43C29.7474 42.901 29.2865 42.7474 28.8906 42.5391V40.4531C29.2865 40.6615 29.7604 40.8385 30.3125 40.9844C30.8698 41.125 31.3932 41.1953 31.8828 41.1953C32.362 41.1953 32.7656 41.1328 33.0938 41.0078C33.4219 40.8776 33.6693 40.6797 33.8359 40.4141C34.0078 40.1432 34.0938 39.7995 34.0938 39.3828C34.0938 38.8255 33.9062 38.3984 33.5312 38.1016C33.1562 37.8047 32.5807 37.6562 31.8047 37.6562C31.5078 37.6562 31.1979 37.6849 30.875 37.7422C30.5573 37.7995 30.2917 37.8568 30.0781 37.9141L29.1172 37.3984L29.5469 31.5781H35.7422V33.625H31.6641L31.4531 35.8672C31.6302 35.8307 31.8229 35.7943 32.0312 35.7578C32.2396 35.7214 32.5312 35.7031 32.9062 35.7031ZM47.8906 43H45.1406L42.1484 38.1875L41.125 38.9219V43H38.7031V31.5781H41.125V36.8047C41.2865 36.5807 41.4453 36.3568 41.6016 36.1328C41.7578 35.9089 41.9167 35.6849 42.0781 35.4609L45.1719 31.5781H47.8594L43.875 36.6328L47.8906 43Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4116",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869347,
    stopColor: "#820375"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip5000);
export default __webpack_public_path__ + "static/media/chip5000.85c4d53a076cb02502b813ddb4fe2b5d.svg";
export { ForwardRef as ReactComponent };